import Card from 'features/shared/components/card/Card';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

type Props = {}

const TermsAndConditionsSection = (props: Props) => {
  // tranlations
  const { t } = useTranslation("conditions\\conditions");

  // render
  return (
    <Card className="p-4">
      <div dangerouslySetInnerHTML={{ __html: t("termsAndConditionsSection.content") || "" }} />
    </Card>
  )
}

export default TermsAndConditionsSection;